/* esm.sh - applesauce-loaders@5.1.0/dist/helpers/address-pointer */
export * from "/*applesauce-loaders@5.1.0/esnext/dist/helpers/address-pointer.mjs";
